import React, { useState, useRef, useCallback, useEffect } from 'react';
import Grid from '@mui/material/Grid';
import Typography from '../../layouts/theme-onboarding/Typography';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '../../layouts/theme-onboarding/Button';
import UploadIcon from '@mui/icons-material/Upload';
import { styled } from '@mui/material/styles';
import ReplayIcon from '@mui/icons-material/Replay';
import FrontCardData from './ocrekyc/FrontCardData';
import BackCardData from './ocrekyc/BackCardData';
import PortraitData from './ocrekyc/PortraitData';
import { showAlert } from '../../redux/create-actions/AlertAction';
import { useDispatch } from 'react-redux';
import Webcam from "react-webcam";
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import { initStep1Data } from '../../utils/object/Signup';
import { backToFirstStep } from '../../redux/create-actions/OnboardingAction';
import Stack from '@mui/material/Stack';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import { openLoadingApi, closeLoadingApi } from '../../redux/create-actions/LoadingAction';
import Color from '../../layouts/Color';
import { graphUploadFaceImage, graphUploadIdCard } from '../../services/Onboarding';

const Input = styled('input')({
  display: 'none',
});

const videoConstraints = {
  width: 220,
  height: 200,
  facingMode: "user"
};

const info = { textAlign: 'left' };
const container = { mt: 1 };
const iconColor = { color: Color.Main };
const card = { maxWidth: 345 };
const gridRender = { padding: 1 };
const webCamPadding = { padding: 2 };

export default function OcrAndEkyc(props) {
  const [frontImage, setFrontImage] = useState(null);
  const [backImage, setBackImage] = useState(null);
  const [portraitImage, setPortraitImage] = useState(null);
  const [eKycFrontResponse, setEkycFrontResponse] = useState(null);
  const [eKycBackResponse, setEkycBackResponse] = useState(null);
  const [eKycFaceResponse, setEkycFaceResponse] = useState(null);

  const dispatch = useDispatch();
  const customerId = props.customerId;
  const webcamRef = useRef(null);

  useEffect(() => {
    if (props.renderEkyc === false) {
      setEkycFrontResponse(props.step1RollBack.eKycFrontResponse);
      setEkycBackResponse(props.step1RollBack.eKycBackResponse);
      setEkycFaceResponse(props.step1RollBack.eKycFaceResponse);
    }
  }, [props.renderEkyc, props.step1RollBack]);


  const captureEKycImg = useCallback(
    async () => {
      let alert = {
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'center'
        },
        isOpen: true,
        severity: 'error',
        title: 'Error',
        message: '',
      };
      if (frontImage === null || backImage === null) {
        alert = { ...alert, message: "Please upload front and back identify card!" };
        dispatch(showAlert(alert));
      } else {
        const img = webcamRef.current.getScreenshot({ width: 640, height: 480 });
        const blod = await fetch(img).then((res) => res.blob());
        const fileName = Date.now() + customerId + '.jpg';
        const file = new File([blod], fileName, { type: blod.type });
        let size = img.size / 1024 / 1024 / 1024;
        if (size > 5) {
          alert = { ...alert, message: "This file size is more than 5MB!" };
          dispatch(showAlert(alert));
        } else {
          if (frontImage === null || backImage === null) {
            alert = { ...alert, message: "Please upload front and back identify card!" };
            dispatch(showAlert(alert));
          } else {
            dispatch(openLoadingApi());
            let promise = graphUploadFaceImage(customerId, file, frontImage);
            promise.then(result => {
              let res = result.data;
              if (res.data !== null) {
                alert = { ...alert, severity: 'success', title: 'Success', message: "Verify eKyc successful" };
                setPortraitImage(file);
                let ekycPortrait = res.data.EkycFaceMatch.responseData.face_match;
                setEkycFaceResponse(ekycPortrait);
                props.onUpdateStep1Data(initStep1Data(eKycFrontResponse, eKycBackResponse, ekycPortrait));
                dispatch(closeLoadingApi());
                dispatch(showAlert(alert));
              } else {
                alert = { ...alert, message: res.errors[0].message };
                dispatch(closeLoadingApi());
                dispatch(showAlert(alert));
              }
            }).catch(function (error) {
              console.log(error);
              dispatch(closeLoadingApi);
            })
          }
        }
      }
    },
    [webcamRef, customerId, backImage, frontImage, eKycFrontResponse, eKycBackResponse, props, dispatch]
  );

  const reCaptureEKycImg = () => {
    let alert = {
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'center'
      },
      isOpen: true,
      severity: 'error',
      title: 'Error',
      message: '',
    };
    setPortraitImage(null);
    setEkycFaceResponse(null);
    props.onUpdateStep1Data(initStep1Data(eKycFrontResponse, eKycBackResponse, null));
    alert = { ...alert, severity: 'success', title: 'Success', message: "Please capture face again!" };
    dispatch(showAlert(alert));
  }

  const changeFrontCardImage = async (event) => {
    let img = event.target.files[0];
    let size = img.size / 1024 / 1024 / 1024;
    let alert = {
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'center'
      },
      isOpen: true,
      severity: 'error',
      title: 'Error',
      message: '',
    };
    if (size > 5) {
      alert = { ...alert, message: "This file size is more than 5MB!" };
      dispatch(showAlert(alert));
    } else {
      dispatch(openLoadingApi());
      let promise = graphUploadIdCard(customerId, "FRONT", img);
      promise.then(result => {
        let res = result.data;
        if (res.data !== null) {
          let ekycFront = res.data.EkycIdCard.responseData.front;
          if (ekycFront !== null && ekycFront.id !== props.idNumber) {
            alert = { ...alert, message: "Please provide correct identify number!" };
            dispatch(closeLoadingApi());
            dispatch(showAlert(alert));
            dispatch(backToFirstStep());
          } else {
            alert = { ...alert, severity: 'success', title: 'Success', message: "Upload image successful" };
            setFrontImage(img);
            setEkycFrontResponse(ekycFront);
            props.onUpdateStep1Data(initStep1Data(ekycFront, eKycBackResponse, eKycFaceResponse));
            dispatch(closeLoadingApi());
            dispatch(showAlert(alert));
          }
        } else {
          alert = { ...alert, message: res.errors[0].message };
          dispatch(closeLoadingApi());
          dispatch(showAlert(alert));
        }
      }).catch((error) => {
        const err = JSON.parse(JSON.stringify(error))
        alert = { ...alert, message: err.response.errors[0].message };
        dispatch(closeLoadingApi());
        dispatch(showAlert(alert));
      });
    }
  }

  const changeBackCardImage = (event) => {
    let img = event.target.files[0];
    let size = img.size / 1024 / 1024 / 1024;
    let alert = {
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'center'
      },
      isOpen: true,
      severity: 'error',
      title: 'Error',
      message: '',
    };
    if (size > 5) {
      alert = { ...alert, message: "This file size is more than 5MB!" };
      dispatch(showAlert(alert));
    } else {
      dispatch(openLoadingApi());
      let promise = graphUploadIdCard(customerId, "BACK", img);
      promise.then(result => {
        let res = result.data;
        if (res.data !== null) {
          let ekycBack = res.data.EkycIdCard.responseData.back;
          alert = { ...alert, severity: 'success', title: 'Success', message: "Upload image successful" };
          setBackImage(img);
          setEkycBackResponse(ekycBack);
          props.onUpdateStep1Data(initStep1Data(eKycFrontResponse, ekycBack, eKycFaceResponse));
          dispatch(closeLoadingApi());
          dispatch(showAlert(alert));
        } else {
          alert = { ...alert, message: res.errors[0].message };
          dispatch(closeLoadingApi());
          dispatch(showAlert(alert));
        }
      }).catch(function (error) {
        const err = JSON.parse(JSON.stringify(error))
        alert = { ...alert, message: err.response.errors[0].message };
        dispatch(closeLoadingApi());
        dispatch(showAlert(alert));
      });
    }
  }

  const renderReloadButtonForFrontCard = (image) => {
    return image === null ? (<Grid item xs={12} sm={12} md={12} lg={12} >
      <label htmlFor="contained-button-file-font">
        <Input accept="image/*" id="contained-button-file-font" multiple type="file" onChange={changeFrontCardImage} />
        <Button variant="outlined" endIcon={<UploadIcon></UploadIcon>} size="medium" component="span" color="error" >
          Upload
        </Button>
      </label>
    </Grid>) : (<Grid item xs={12} sm={12} md={12} lg={12}>
      <label htmlFor="contained-button-file-font">
        <Input accept="image/*" id="contained-button-file-font" multiple type="file" onChange={changeFrontCardImage} />
        <Button variant="outlined" endIcon={<ReplayIcon></ReplayIcon>} size="medium" component="span" color="error">
          Reload
        </Button>
      </label>
    </Grid>);
  }

  const renderReloadButtonForBackCard = (image) => {
    return image === null ? (<Grid item xs={12} sm={12} md={12} lg={12} >
      <label htmlFor="contained-button-file-back">
        <Input accept="image/*" id="contained-button-file-back" multiple type="file" onChange={changeBackCardImage} />
        <Button variant="outlined" endIcon={<UploadIcon></UploadIcon>} size="medium" component="span" color="error" >
          Upload
        </Button>
      </label>
    </Grid>) : (<Grid item xs={12} sm={12} md={12} lg={12}>
      <label htmlFor="contained-button-file-back">
        <Input accept="image/*" id="contained-button-file-back" multiple type="file" onChange={changeBackCardImage} />
        <Button variant="outlined" endIcon={<ReplayIcon></ReplayIcon>} size="medium" component="span" color="error">
          Reload
        </Button>
      </label>
    </Grid>);
  }

  const renderCaptureButton = (image) => {
    return image === null ? (<Grid item xs={12} sm={12} md={12} lg={12}>
      <Button variant="outlined" size="medium" component="span" endIcon={<PhotoCameraIcon></PhotoCameraIcon>}
        color="error" onClick={captureEKycImg}>
        Capture
      </Button>
    </Grid>) : (<Grid item xs={12} sm={12} md={12} lg={12}>
      <Button variant="outlined" size="medium" component="span" endIcon={<PhotoCameraIcon></PhotoCameraIcon>}
        color="error" onClick={reCaptureEKycImg}>
        Capture
      </Button>
    </Grid>);
  }

  const renderPreviewCardImage = (image) => {
    return (image === null) ? (
      <CardMedia
        component="img"
        image={process.env.PUBLIC_URL + '/assets/images/signup/upload-card-id.jpg'}
        alt="identify-upload"
        height={200}
      />
    ) : (<CardMedia
      component="img"
      image={URL.createObjectURL(image)}
      alt="identify-upload"
      height="80%"
    />);
  }

  const renderWebCam = (image, front, back) => {
    if (front === null || back === null) {
      return (<CardMedia
        component="img"
        image={process.env.PUBLIC_URL + '/assets/images/signup/upload-card-id.jpg'}
        alt="identify-upload"
        height={200}
      />);
    } else {
      return (image === null) ? (
        <Webcam
          style={webCamPadding}
          audio={false}
          height={250}
          screenshotFormat="image/jpeg"
          width={300}
          videoConstraints={videoConstraints}
          ref={webcamRef}
        />
      ) : (<CardMedia
        component="img"
        image={URL.createObjectURL(image)}
        alt="identify-upload"
        height={260}
      />);
    }
  }

  const renderFrontCard = (data) => {
    return data === true ? (<Card sx={card}>
      {renderPreviewCardImage(frontImage)}
      <CardContent>
        <Typography variant="subtitle1" color={Color.Main} component="div">
          Front-Card
        </Typography>
      </CardContent>
      <CardActions>
        <Grid container maxWidth="sm" spacing={3} sx={gridRender}>
          {renderReloadButtonForFrontCard(frontImage)}
        </Grid>
      </CardActions>
    </Card>) : (<div></div>)
  }

  const renderBackCard = (data) => {
    return data === true ? (<Card sx={card}>
      {renderPreviewCardImage(backImage)}
      <CardContent>
        <Typography variant="subtitle1" color={Color.Main} component="div">
          Back-Card
        </Typography>
      </CardContent>
      <CardActions>
        <Grid container maxWidth="sm" spacing={3} sx={gridRender}>
          {renderReloadButtonForBackCard(backImage)}
        </Grid>
      </CardActions>
    </Card>) : (<div></div>)
  }

  const renderWebCamera = (data) => {
    return data === true ? (<Card sx={card}>
      {renderWebCam(portraitImage, frontImage, backImage)}
      <CardContent>
        <Typography variant="subtitle1" color={Color.Main} component="div">
          Face-Check
        </Typography>
      </CardContent>
      <CardActions>
        <Grid container maxWidth="sm" spacing={3} sx={gridRender}>
          {renderCaptureButton(portraitImage)}
        </Grid>
      </CardActions>
    </Card>) : (<div></div>)
  }

  return (
    <React.Fragment>
      <Stack direction="row" justifyContent="center" spacing={1}>
        <Typography variant="h6" marked="left" gutterBottom color={Color.Main}>OCR & EKYC</Typography>
        <VerifiedUserIcon sx={iconColor}></VerifiedUserIcon>
      </Stack>
      <Grid container spacing={3} sx={container}>
        <Grid item xs={12} sx={info}>
          <Typography variant="subtitle1" color={Color.Main}>Please provide ID / IDC photo and portrait to verify information: </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          {renderFrontCard(props.renderEkyc)}
          <FrontCardData eKycFrontResponse={eKycFrontResponse}></FrontCardData>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>

          {renderBackCard(props.renderEkyc)}
          <BackCardData eKycBackResponse={eKycBackResponse}></BackCardData>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          {renderWebCamera(props.renderEkyc)}
          <PortraitData eKycFaceResponse={eKycFaceResponse}></PortraitData>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}